import { render } from "./Form.vue?vue&type=template&id=a5ee010a&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=a5ee010a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5ee010a"

export default script